var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkout"},[(_vm.loading)?_c('Spinner',{staticClass:"text-primary",attrs:{"size":'lg',"center":true}}):_vm._e(),_c('div',{ref:"conektaIframeContainer",staticClass:"position-absolute top-50 start-50 translate-middle",staticStyle:{"height":"500px","width":"500px"},attrs:{"id":"conektaIframeContainer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }